import { PriceChange, PriceHistory } from '@toggle/toggle';

export const DATE_FORMAT = 'yyyy-MM-dd';

export type PriceByDay = Record<string, PriceChange>;

export interface VariantDataArgs {
  days: string[];
  priceByDay: PriceByDay;
  reportingDateET: Date;
  isReportingPreMarket: boolean;
  prevCloseHistoryData?: PriceHistory;
  isLoading: boolean;
}

export interface VariantDataResult {
  priceData: PriceChange;
  fromDateEST: Date;
  toDateEST: Date;
  lastProportionChange?: number;
  prevCloseData?: PriceHistory[number];
  lastKnownPrice?: number;
  lastKnownDate?: string;
  isLoading: boolean;
}

export const computePriceMetrics = (
  priceData: PriceChange,
  prevCloseHistoryData?: PriceHistory
) => {
  const lastKnownData = priceData[priceData.length - 1];
  const startOfDayUTC = priceData[0]?.time?.replace(/T.*/, 'T00:00:00Z');

  const prevCloseData = prevCloseHistoryData?.findLast(h =>
    startOfDayUTC ? h.time < startOfDayUTC : false
  );

  const lastKnownPrice = lastKnownData?.value;
  const lastProportionChange =
    lastKnownPrice && prevCloseData?.close
      ? ((lastKnownPrice - prevCloseData.close) / prevCloseData.close) * 100
      : undefined;

  return {
    prevCloseData,
    lastKnownPrice,
    lastProportionChange,
    lastKnownDate: lastKnownData?.time,
  };
};
